import { ArrowHeadRightIcon, Checkbox, Chip, Select, SelectOptionType } from '@bp/ui-components';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { lowercaseFirstLetter, naturalStringSort } from 'utils/stringHelper';
import styles from './_PlanungImportForms.module.scss';

type PlanungImportLessonsFormRowProps = {
  uuid: string;
  selected: boolean;
  name: string;
  lessons: { uuid: string; name: string }[];
  selectedLesson: { value: string; label: string } | null;
  connected: boolean;
  onSelect: (isSelected: boolean) => void;
  onLessonSelect: (uuid: string | null) => void;
};

export const PlanungImportLessonsFormRow = ({
  uuid,
  selected,
  name,
  lessons,
  selectedLesson,
  connected,
  onSelect,
  onLessonSelect,
}: PlanungImportLessonsFormRowProps) => {
  const { t } = useTranslation();

  const lessonOptions: SelectOptionType[] = lessons
    .map((l) => ({ value: l.uuid, label: l.name }))
    .sort((a, b) => naturalStringSort(a.label, b.label));

  return (
    <div className={classNames(styles['form-row'], styles.lessons, { [styles.selected]: selected })}>
      <div>
        <Checkbox
          onChange={(event) => {
            onSelect(event.target.checked);
          }}
          checked={selected}
          name={`check-${uuid}`}
          label={name}
          preventLabelWrapping
        />
      </div>
      <div>
        <ArrowHeadRightIcon />
      </div>
      <div>
        <Select
          dense
          options={lessonOptions}
          name={`select-lesson-${uuid}`}
          placeholder={selected ? lowercaseFirstLetter(t('planungImport.willBeCreated')) : undefined}
          onChange={(event) => {
            const selectOption = event as SelectOptionType;
            const uuid = selectOption ? (selectOption.value as string) : null;
            onLessonSelect(uuid);
          }}
          value={selectedLesson}
          isClearable
          isSearchable
          menuPosition='fixed'
          disabled={!selected}
        />
      </div>
      <div>
        <Chip
          isSmall
          value={connected ? <>&#10003;</> : <>&#8212;</>}
          color={connected ? 'var(--color-white)' : 'var(--color-grey-light)'}
          bgColor={connected ? 'var(--color-primary)' : 'var(--color-grey-lighter)'}
        />
      </div>
    </div>
  );
};
